






















































































import {
  defineComponent,
  reactive,
  ref,
  Ref,
  watch,
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  onUnmounted,
  PropType,
} from '@vue/composition-api';
import { debounce } from 'lodash';
import { TreeNodeModel } from 'tdesign-vue';
import { HelpCircleIcon } from 'tdesign-icons-vue';

import PermissionHelp from '@/renderer/components/drawer/FilterDrawer/components/PermissionHelp.vue';

// 引入工具类
import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/smh';
import ipc from '@/renderer/scripts/utils/ipc';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';

// 引入 compositions
import useTeamSpaceTree from './compositions/useTeamSpaceTree';
import useCollaborationSpace from './compositions/useCollaborationSpace';

export default defineComponent({
  name: 'filterDrawer',
  components: { PermissionHelp, HelpCircleIcon },
  props: {
    filterScope: {
      required: false,
      type: Array as PropType<('fileTotal' | 'fileScope' | 'viewScope')[]>,
      default: () => {
        return ['fileTotal', 'fileScope', 'viewScope'];
      },
    },
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;

    const isRecycleBin = computed(() => {
      return vm.$route.name === 'recycleBin';
    });
    // 查看范围的数据
    const viewOptions = [
      {
        label: i18n_t('仅查看我删除的文件'),
        value: 'mine',
      },
      {
        label: i18n_t('查看所有删除的文件'),
        value: 'all',
      },
    ];
    const isTemporary = computed(() => vm.$store.getters.userBaseInfo.isTemporary);
    const showTitle = computed(() => {
      if (isTemporary.value) {
        return coData.list.length !== 0;
      }
      return true;
    });
    const fileScopeShow = computed(() => {
      const { editionFlag, hasPersonalSpace } = vm.$store.getters;
      return {
        teamSpace: editionFlag !== 'personal' && !isTemporary.value,
        coSpace: coData.list.length !== 0,
        personalSpace: hasPersonalSpace && !isTemporary.value,
      };
    });

    let personalSpaceId = '';
    const personalSpaceChecked = ref(true);
    const { teamData, teamTreeKey, teamIndeterminate, methods: teamSpaceTreeMethods } = useTeamSpaceTree();
    const { coData, coIndeterminate, coSpaceItems, methods: coSpaceMethods } = useCollaborationSpace();
    const selectView = ref<'mine' | 'all'>('mine');

    const showTeamTree = ref(false);
    const showCollaboration = ref(false);
    const totalNum = ref(0);

    const isShowPermission = ref(false);

    const methods = {
      // 初始化
      async initData() {
        // 将勾选状态重置
        personalSpaceChecked.value = true;
        try {
          personalSpaceId = await spaceATM.getPersonalSpaceIdAsync();
        } catch (error) {
          personalSpaceChecked.value = false;
        }
        await coSpaceMethods.initData();
        await teamSpaceTreeMethods.initData();
        // 默认传所有的数据过去
        methods.debounceIpcMessage();
      },
      changeActive(type: string) {
        if (type === 'team') {
          teamSpaceTreeMethods.triggerTeamSpaceChecked();
        } else if (type === 'collaboration') {
          coSpaceMethods.triggerCoSpaceChecked();
        } else if (type === 'personal') {
          personalSpaceChecked.value = !personalSpaceChecked.value;
        }
        methods.debounceIpcMessage();
      },
      changeView(value: 'mine' | 'all') {
        selectView.value = value;
        methods.debounceIpcMessage();
      },
      async changeTeamNode(
        value: SMH.SpaceId[],
        context: {
          node: TreeNodeModel;
        },
      ) {
        await teamSpaceTreeMethods.changeTeamNode(value, context);
        methods.debounceIpcMessage();
      },
      changeCollaboration(item: any) {
        coSpaceMethods.changeCoSpaceItemChecked(item);
        methods.debounceIpcMessage();
      },
      // 不要过于频繁的操作去获取数据
      debounceIpcMessage: debounce(
        () => {
          const teamScope = teamSpaceTreeMethods.getTeamSpaceItems();
          const collaborationScope = coSpaceItems.value;
          const personalScope = personalSpaceChecked.value
            ? [
                {
                  spaceId: personalSpaceId,
                  includeChildSpace: false,
                },
              ]
            : [];

          const params = {
            teamScope,
            collaborationScope,
            personalScope,
            selectView: selectView.value,
          };
          ipc.emit(ipc.RENDERER_EVENTS_MAP.RECYCLE_FILE_SCOPE, params);
        },
        500,
        { leading: false },
      ),
      triggerTeamTree() {
        showTeamTree.value = !showTeamTree.value;
      },
      changeTotalNum(value: number) {
        totalNum.value = value;
      },
      showPermissionDialog() {
        isShowPermission.value = true;
      },
    };

    // 切换路由要重置抽屉
    watch(
      () => vm.$route.name,
      newVal => {
        methods.initData();
      },
      {
        immediate: true,
      },
    );

    ipc.on(ipc.RENDERER_EVENTS_MAP.RECYCLE_TOTAL, methods.changeTotalNum);
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.RECYCLE_TOTAL, methods.changeTotalNum);
    });

    return {
      viewOptions,
      personalSpaceChecked,
      teamData,
      teamIndeterminate,
      ...teamSpaceTreeMethods,
      coData,
      coIndeterminate,
      ...methods,
      teamTreeKey,
      selectView,
      showCollaboration,
      showTeamTree,
      totalNum,
      isRecycleBin,
      isTemporary,
      showTitle,
      isShowPermission,
      fileScopeShow,
    };
  },
});
